<script>
/**
 * @overview 课时详情 - 元素组件
 *
 * @author huojinzhao
 */

export default {
  name: "CourseDetailElement",

  props: {
    label: {
      type: String,
      required: true,
    },

    statusType: {
      type: [String, Number],
      required: true,
    },

    statusName: {
      type: [String, Number],
      required: true,
    },
  },

  methods: {
    setStatusClass(status) {
      const statusMap = [
        "",
        "state-intaglio-warning",
        "state-intaglio-primary",
        "state-intaglio-success",
      ];

      return statusMap[status];
    },

    detailImport() {
      this.$refs.file.click();
    },

    inputExcel({ target }) {
      this.$emit("import", target.files[0]);
      this.$refs.file.value = null;
    },

    detailEdit() {
      console.log("detailEdit");
      this.$emit("edit");
    },

    detailPrepare() {
      console.log("detailPrepare");
      this.$emit("prepare");
    },
    detailPreview() {
      this.$emit("preview");
    },
  },
};
</script>

<template>
  <AppMasker
    v-bind="$attrs"
    class="course-detail-element"
    @import="detailImport"
    @edit="detailEdit"
    @prepare="detailPrepare"
    @preview="detailPreview"
  >
    <span>{{ label }}</span>
    <span :class="setStatusClass(statusType)">
      {{ statusName }}
    </span>
    <input
      v-show="false"
      ref="file"
      type="file"
      @input="inputExcel"
    >
  </AppMasker>
</template>

<style lang="postcss">
.course-detail-element {

}
</style>
